export default {
  // list
  'base_cost_item.query.costItemName': '费用项目名称',
  'base_cost_item.query.costItemName.placeholder': '请输入费用项目名称',
  'base_cost_item.query.financialName': '财务名称',
  'base_cost_item.query.financialName.placeholder': '请输入财务名称',
  'base_cost_item.query.financialCode': '财务编码',
  'base_cost_item.query.financialCode.placeholder': '请输入财务编码',
  'base_cost_item.column.costItemName': '费用项目名称',
  'base_cost_item.column.costItemTaxRate': '税率%',
  'base_cost_item.column.financialName': '财务名称',
  'base_cost_item.column.financialCode': '财务编码',
  'base_cost_item.column.createBy': '创建人',
  'base_cost_item.column.updateBy': '更新人',
  'base_cost_item.column.createTime': '创建时间',
  'base_cost_item.column.updateTime': '更新时间',
  'base_cost_item.column.dataSource': '数据来源',
  'base_cost_item.column.remark': '备注',
  'base_cost_item.column.status': '状态',
  // edit
  'base_cost_item.edit.title': '编辑费用项目',
  'base_cost_item.add.title': '新增费用项目',
  'base_cost_item.edit.success': '编辑成功',
  'base_cost_item.add.success': '新增成功',
  'base_cost_item.form.costItemName.required': '费用项目名称不能为空',
  'base_cost_item.form.costItemName': '费用项目名称',
  'base_cost_item.form.costItemName.placeholder': '请输入费用项目名称',
  'base_cost_item.form.costItemTaxRate': '税率',
  'base_cost_item.form.costItemTaxRate.placeholder': '请输入税率',
  'base_cost_item.form.financialName': '财务名称',
  'base_cost_item.form.financialName.placeholder': '请输入财务名称',
  'base_cost_item.form.financialCode': '财务编码',
  'base_cost_item.form.financialCode.placeholder': '请输入财务编码',
}
